import { createSelector } from 'reselect'
import compact from 'lodash/compact'
import isEmpty from 'lodash/isEmpty'

import {
  TASTE_PROFILE_FILTER,
  PRICE_FILTER
} from 'constants/filtering'

export const selectQuestions = (state) => state.tasteProfileOnboarding.questions
const getCurrentSlug = (state, nextProps) => nextProps.params
export const resultDomain = (state) => state.tasteProfileOnboarding.result

export const selectNextUrl = createSelector(
  [selectQuestions, getCurrentSlug],
  (questions, params) => {
    const url = params.question || ''
    const questionNumber = questions.findIndex((v) => v.url === url)
    const newQuestion = questions[questionNumber + 1]

    // Return new question url if there is one
    if (newQuestion) {
      const questionUrl = newQuestion.url
      return `vragen/${questionUrl}/`
    }

    // If there is just one or no unanswered questions left, it should go to result page
    // Make sure the questions are fetched
    const unanswered = questions.filter((v) => !('answered' in v))
    if (questions.length > 0 && unanswered.length <= 1) {
      return 'mijn-profiel'
    }

    // Goto start and give a message if there are images left
    return ''
  }
)

export const selectBrowser = (state) => state.browser

export const selectNextImages = createSelector(
  [selectQuestions, selectNextUrl],
  (questions, nextUrl) => {
    // get only the last part of the url
    const nextQuestionUrl = compact(nextUrl.split('/')).pop()
    const nextQuestion = questions.find((question) => question.url === nextQuestionUrl)

    if (nextQuestion) {
      const choices = nextQuestion.choices
      const images = choices.map((choice) => choice.imageUrl)
      return images
    }

    return []
  }
)

export const questionsLoadedSelector = createSelector(
  selectQuestions,
  (questions) => questions.length > 0
)

export const selectOrderings = (state) => state.tasteProfileOnboarding.orderings

export const selectOrderBy = (state) => {
  const { orderings } = state.tasteProfileOnboarding
  if (isEmpty(orderings)) {
    return null
  }
  return orderings.options.find(({ selected }) => selected).value
}

export const selectFilters = (state) => state.tasteProfileOnboarding.filters

export const selectTasteProfile = (state) => {
  const environment = state.tasteProfileOnboarding
  const result = environment.result
  if (isEmpty(result)) {
    return null
  }
  const tasteProfileFilter = environment.filters
    .find((obj) => obj.name === TASTE_PROFILE_FILTER.NAME)

  const tasteProfile = tasteProfileFilter.options
    .find((obj) => obj.selected)
    .value

  const color = result.tasteProfiles
    .find((obj) => obj.name === tasteProfile)
    .color

  const tasteType = result.tasteTypes
    .find((obj) => obj.color === color)
    .name

  const tasteElements = result.tasteElements

  return {
    tasteProfile,
    tasteType,
    ...tasteElements
  }
}

export const selectTasteProfiles = createSelector(
  resultDomain,
  (result) => result.tasteProfiles
)

export const selectPriceRange = (state) => {
  const highestPriceAvailable = PRICE_FILTER.OPTIONS[PRICE_FILTER.OPTIONS.length - 1]
  const environment = state.tasteProfileOnboarding
  const priceFilter = environment
    .filters
    .find((obj) => obj.name === PRICE_FILTER.NAME)

  let min = PRICE_FILTER.OPTIONS[0]
  let max = highestPriceAvailable
  if (priceFilter) {
    min = priceFilter.min
    max = priceFilter.max
  }

  if (priceFilter) {
    // always pass `maxPrice` variable to GraphQL query because Apollo Client
    // merges previous variables with new variables which causes unwanted behavior:
    // https://github.com/apollographql/apollo-client/blob/master/packages/apollo-client/src/core/ObservableQuery.ts#L432

    return {
      minPrice: min,
      maxPrice: (max >= highestPriceAvailable) ? PRICE_FILTER.MAX : max
    }
  }

  return {}
}
